module.exports = __webpack_public_path__ + "img/p8.d9666dd0.png";